import { formatList } from "@memorang/helpers/i18n";
import { getReportSkills } from "@memorang/helpers/report";
import { isProficiencyTag } from "@memorang/helpers/tag";
import type { MixedItemTag } from "@memorang/types";
import type { TFunction } from "i18next";

export const getSummaryMessage = ({
	tags,
	topics,
	numItems,
	t,
	locale,
}: {
	tags: MixedItemTag[];
	topics: string[];
	numItems: number;
	t: TFunction;
	locale: Intl.LocalesArgument;
}) => {
	const skillTags = getReportSkills(tags, topics);
	const skillTitles = skillTags.map((tag) => tag.title);
	const skills = formatList(locale, skillTitles);

	const itemPhrase = t(
		skillTitles.length > 0
			? "session.results.summary.skilledItemCount"
			: "session.results.summary.itemCount",
		{
			count: numItems,
			skills,
		},
	);

	const proficiencyTags = tags.filter((tag) => isProficiencyTag(tag));
	const levelTitles = proficiencyTags.map((tag) => tag.title);

	if (skillTitles.length > 0 && levelTitles.length > 0) {
		return {
			key: "session.results.summary.messageWithLevels",
			values: {
				itemPhrase,
				count: numItems,
				skills,
				levelCount: levelTitles.length,
				levels: formatList(locale, levelTitles),
			},
		};
	}

	return {
		key: "session.results.summary.message",
		values: {
			itemPhrase,
		},
	};
};
